var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGuestIn(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_19319",
    "data-name": "Group 19319",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_5382",
    "data-name": "Rectangle 5382",
    width: 16,
    height: 16,
    transform: "translate(0 0)",
    fill: "#c3c3c3"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_19313",
    "data-name": "Group 19313",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_247892",
    "data-name": "Path 247892",
    d: "M232.133,262.5a2.133,2.133,0,1,0,2.133,2.133,2.135,2.135,0,0,0-2.133-2.133m0,3.2a1.067,1.067,0,1,1,1.067-1.067,1.068,1.068,0,0,1-1.067,1.067",
    transform: "translate(-226.729 -258.767)",
    fill: "#c3c3c3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_247893",
    "data-name": "Path 247893",
    d: "M160.281,607.65a.535.535,0,0,0-.6-.068,3.256,3.256,0,0,1-2.971,0,.535.535,0,0,0-.6.068A3.2,3.2,0,0,0,155,610.081v.533a.533.533,0,0,0,.533.533h5.333a.533.533,0,0,0,.533-.533v-.533a3.2,3.2,0,0,0-1.119-2.431m-4.214,2.431a2.136,2.136,0,0,1,.512-1.386,4.329,4.329,0,0,0,3.242,0,2.136,2.136,0,0,1,.512,1.386Z",
    transform: "translate(-152.796 -598.881)",
    fill: "#c3c3c3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_247894",
    "data-name": "Path 247894",
    d: "M680.867,302.122h-1.6v-1.6a.533.533,0,0,0-.533-.533h0a.533.533,0,0,0-.377.156l-3.2,3.2a.533.533,0,0,0,0,.754l3.2,3.2a.533.533,0,0,0,.91-.377v-1.6h1.6a.533.533,0,0,0,.533-.533v-2.133a.533.533,0,0,0-.533-.533m-.754,2.133h-1.6a.533.533,0,0,0-.533.533v.846l-1.912-1.912,1.912-1.912v.846a.533.533,0,0,0,.533.533h1.6Z",
    transform: "translate(-665.4 -295.723)",
    fill: "#c3c3c3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_247895",
    "data-name": "Path 247895",
    d: "M8.533,15.467A.533.533,0,0,0,8,14.933H2.133a1.068,1.068,0,0,1-1.067-1.067V2.133A1.068,1.068,0,0,1,2.133,1.067H8A.533.533,0,1,0,8,0H2.133A2.135,2.135,0,0,0,0,2.133V13.867A2.135,2.135,0,0,0,2.133,16H8a.533.533,0,0,0,.533-.533",
    transform: "translate(0 0)",
    fill: "#c3c3c3"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGuestIn);
export default __webpack_public_path__ + "static/media/guestIn.4bb0582a22ee29192fa77ab3913e3b56.svg";
export { ForwardRef as ReactComponent };